import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {

  constructor(private tokenExtractor: HttpXsrfTokenExtractor) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lcUrl = request.url.toLowerCase();

    // Do not attach CSRF to absolute or protocol-relative URLs (CVE-2025-66035 / GHSA-58c5-g7wp-6w37)
    if (
      request.method === 'GET' ||
      request.method === 'HEAD' ||
      lcUrl.startsWith('http://') ||
      lcUrl.startsWith('https://') ||
      lcUrl.startsWith('//')
    ) {
      return next.handle(request);
    }

    const cookieheaderName = 'X-CSRF-TOKEN';
    let csrfToken = this.tokenExtractor.getToken() as string;

    if (csrfToken !== null && !request.headers.has(cookieheaderName)) {
      request = request.clone({ headers: request.headers.set(cookieheaderName, csrfToken) });
    }
    return next.handle(request);

  }

}
